var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.6219 6.41459L13.5008 9.6672C13.6846 9.7897 13.7343 10.0381 13.6117 10.2219C13.5824 10.2658 13.5447 10.3035 13.5008 10.3328L8.6219 13.5854C8.4381 13.708 8.1897 13.6583 8.0672 13.4745C8.0234 13.4088 8 13.3316 8 13.2526V6.74741C8 6.52649 8.1791 6.34741 8.4 6.34741C8.479 6.34741 8.5562 6.37078 8.6219 6.41459Z",
    fill: "#4659CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/videoPlayer.10896eb0b36ba85d8e99d9cc67d30fa1.svg";
export { ForwardRef as ReactComponent };